//@flow
import React from 'react';
import PriceSummary from './PriceSummary.react';
import CSSTransition from 'react-transition-group/CSSTransition';
import MediaQuery from 'react-responsive';
import PromoCode from '../../PromoCode/components/PromoCode.react';
import IconExpandArrow from '../../Icon/components/IconExpandArrow.react';

import type QuoteTotalsModel from '../../Stores/Quote/quoteTotalsModel';
import type MembershipPlanModel from '../../Stores/Membership/membershipPlanModel';
import type QuoteModel from '../../Stores/Quote/quoteModel';

type Props = {
  inCheckout?:boolean,
  quoteTotals:QuoteTotalsModel,
  newMember:boolean,
  loggedIn?:boolean,
  membershipPlan:MembershipPlanModel,
  quote:QuoteModel,
  className:string,
  toggleSummary:() => void,
  summaryOpen:boolean,
  showGiftUI:boolean,
  hidePromoCodeInput:boolean,
  hideMembershipOption:boolean,
};

function _getPriceSummary(props:Props) {
  return (
    <MediaQuery minHeight={460}>
      <PriceSummary
        quoteTotals={props.quoteTotals}
        inCheckout={props.inCheckout}
        newMember={props.newMember}
        loggedIn={props.loggedIn}
        inCartPreview={true}
        membershipPlan={props.membershipPlan}
        quote={props.quote}
        showMsrpRow={true}
        hasSubscription={false}
        hideMembershipOption={props.hideMembershipOption}
      />
      {!props.hidePromoCodeInput &&
        <PromoCode
          quoteTotals={props.quoteTotals}
          quote={props.quote}
          showInput={true}
          showPromoCodePrompt={true}
          showGiftUI={props.showGiftUI}
        />
      }
    </MediaQuery>
  );
}

function _getAdditionalDiscount(discount:number) {
  if (discount) {
    return (
      <div className="discount">
        (promotion applied)
      </div>
    );
  }
}

export default function PriceToggle(props:Props) {
  const subtotal= props.quoteTotals.getSubtotal() || 0;
  const discount = props.quoteTotals.getDiscount() || 0;
  const showClass = props.summaryOpen ? "show" : "hide";
  const arrowClass = props.newMember ? 'arrow-holder new-member' : 'arrow-holder';
  return (
    <div className={`price-toggle ${props.className}`}>
      <div onClick={props.toggleSummary} className="toggle-holder">
        <div  className="toggler-top">
          <div className="text-holder">
            <div className="total">
              Subtotal: ${(subtotal + discount).toFixed(2)}
            </div>
            {_getAdditionalDiscount(discount)}
          </div>
        </div>
        <div className={arrowClass}>
          <span className="text">View order total</span>
          <IconExpandArrow
            className="orange"
            reversed={true}
            action={props.toggleSummary}
            expanded={props.summaryOpen}
          />
        </div>
      </div>
      <CSSTransition
        classNames="price-toggle-transition"
        timeout={350}
        in={props.summaryOpen}
      >
        <div className={`${showClass} price-toggle-holder`}>
          {_getPriceSummary(props)}
        </div>
      </CSSTransition>
    </div>
  );
}
